import { t } from './master-xava-i18n.js?v=3.0.0';
import './master-xava-liquid.js?v=3.21.1';
// No WebGL on this route: reading, filling and submitting stay lightweight.
document.querySelectorAll('[data-contact-page]').forEach(page => {
  const select = page.querySelector('[data-contact-service]'), whatsapp = page.querySelector('[data-contact-whatsapp]');
  const title = page.querySelector('.mx-contact-station__intro h1');
  const motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  let titleGlyphs = [], titlePoints = [], lastFrame = performance.now(), titleFrame = 0, titleVisible = true;
  const pointer = { x: innerWidth / 2, y: innerHeight / 2, sx: innerWidth / 2, sy: innerHeight / 2, active: false };

  // Keep the heading as one accessible phrase while its visible glyphs react
  // independently, matching the opening scene without adding WebGL to this page.
  if (title) {
    const accessibleTitle = title.textContent.replace(/\s+/g, ' ').trim();
    title.setAttribute('aria-label', accessibleTitle);
    const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT), textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(node => {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).filter(Boolean).forEach(token => {
        if (/^\s+$/.test(token)) {
          fragment.append(document.createTextNode(' '));
          return;
        }
        const word = document.createElement('span');
        word.className = 'mx-contact-word';
        [...token].forEach(character => {
          const glyph = document.createElement('span');
          glyph.className = 'mx-contact-glyph';
          glyph.setAttribute('aria-hidden', 'true');
          glyph.textContent = character;
          word.append(glyph);
        });
        fragment.append(word);
      });
      node.replaceWith(fragment);
    });
    titleGlyphs = [...title.querySelectorAll('.mx-contact-glyph')];
  }

  const measureTitle = () => {
    if (!finePointer.matches || motionQuery.matches) { titlePoints = []; return; }
    titlePoints = titleGlyphs.map(glyph => {
      const box = glyph.getBoundingClientRect();
      return { x: box.left + box.width / 2, y: box.top + box.height / 2 };
    });
  };
  const resetTitle = () => titleGlyphs.forEach(glyph => {
    glyph.style.transform = '';
    glyph.style.textShadow = '';
  });
  const renderTitle = now => {
    titleFrame = 0;
    if (document.hidden || !titleVisible || !finePointer.matches || motionQuery.matches) return;
    const dt = Math.min(.05, Math.max(.001, (now - lastFrame) / 1000));
    lastFrame = now;
    const ease = 1 - Math.exp(-dt * 8);
    pointer.sx += (pointer.x - pointer.sx) * ease;
    pointer.sy += (pointer.y - pointer.sy) * ease;
    // Read the viewport once before glyph writes, not once per glyph after
    // transforms invalidate style. Touch has no cursor-driven title loop.
    const viewportWidth = innerWidth;
    const interactive = pointer.active && finePointer.matches && !motionQuery.matches;
    titleGlyphs.forEach((glyph, index) => {
      const point = titlePoints[index];
      if (!point) return;
      const dx = point.x - pointer.sx, dy = point.y - pointer.sy;
      const distance = Math.hypot(dx, dy);
      const force = interactive ? Math.pow(Math.max(0, 1 - distance / 240), 2) : 0;
      const float = motionQuery.matches ? 0 : Math.sin(now * .0009 + index * .65) * (finePointer.matches ? 2.4 : .8);
      const x = dx / (distance || 1) * force * 18;
      const y = dy / (distance || 1) * force * 24 + float;
      glyph.style.transform = `translate3d(${x}px,${y}px,0) rotate(${force * Math.sin(index * 2 + now * .001) * 7}deg) skewX(${force * ((pointer.sx / viewportWidth) * 2 - 1) * 9}deg)`;
      glyph.style.textShadow = force > .08 ? `${-force * 4}px 0 #9856f380,${force * 4}px 0 #ccff0070` : 'none';
    });
    titleFrame = requestAnimationFrame(renderTitle);
  };
  if (titleGlyphs.length) {
    const lens = document.createElement('i');
    lens.className = 'mx-contact-title-lens';
    lens.setAttribute('aria-hidden', 'true');
    page.append(lens);
    const syncTitle = () => {
      cancelAnimationFrame(titleFrame); titleFrame = 0;
      if (document.hidden || !titleVisible || !finePointer.matches || motionQuery.matches) {
        pointer.active = false; lens.style.opacity = '0'; resetTitle(); return;
      }
      lastFrame = performance.now(); measureTitle(); titleFrame = requestAnimationFrame(renderTitle);
    };
    const move = event => {
      if (event.pointerType === 'touch' || !finePointer.matches || motionQuery.matches) return;
      pointer.x = event.clientX;
      pointer.y = event.clientY;
      pointer.active = true;
      lens.style.opacity = motionQuery.matches ? '0' : '.62';
      lens.style.transform = `translate3d(${event.clientX}px,${event.clientY}px,0)`;
    };
    page.addEventListener('pointermove', move, { passive: true });
    page.addEventListener('pointerleave', () => { pointer.active = false; lens.style.opacity = '0'; });
    addEventListener('resize', syncTitle, { passive: true });
    addEventListener('scroll', measureTitle, { passive: true });
    document.fonts?.ready.then(measureTitle);
    measureTitle();
    syncTitle();
    motionQuery.addEventListener?.('change', syncTitle);
    finePointer.addEventListener?.('change', syncTitle);
    document.addEventListener('visibilitychange', syncTitle);
    if (typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(([entry]) => { titleVisible = entry.isIntersecting; syncTitle(); });
      observer.observe(title);
      addEventListener('pagehide', event => { cancelAnimationFrame(titleFrame); if (!event.persisted) observer.disconnect(); });
      addEventListener('pageshow', syncTitle);
    }
  }
  const requested = new URLSearchParams(location.search).get('service');
  if ([...select.options].some(option => option.value === requested)) select.value = requested;
  const update = () => {
    const service = select.value === 'other' ? t('iniciar un proyecto con Alto Impacto Visual') : t('un proyecto de ') + select.selectedOptions[0].textContent;
    whatsapp.href = 'https://wa.me/' + whatsapp.dataset.phone + '?text=' + encodeURIComponent(t('Hola, estoy interesado en ') + service + '.');
    page.querySelectorAll('.mx-language a').forEach(link => { const url = new URL(link.href); url.searchParams.set('service', select.value); link.href = url.href; });
    // Shopify localizes this relative return path; keep the chosen service in ES/EN.
    const returnTo = page.querySelector('.mx-language input[name="return_to"]');
    if (returnTo) {
      const url = new URL(location.href);
      url.searchParams.delete('contact_posted');
      url.searchParams.set('service', select.value);
      returnTo.value = url.pathname + url.search;
    }
  };
  select.addEventListener('change', update); update();
  page.querySelector('[data-contact-back]').textContent = t('Volver al universo');
  page.querySelector('[data-contact-result]')?.focus({preventScroll:true});
});
